import { render, staticRenderFns } from "./virtualdrilling.vue?vue&type=template&id=0253ae9b&"
import script from "./virtualdrilling.vue?vue&type=script&lang=js&"
export * from "./virtualdrilling.vue?vue&type=script&lang=js&"
import style0 from "./virtualdrilling.vue?vue&type=style&index=0&id=0253ae9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports